import request from '@/utils/ajax';

export function saveArticle(data){
  return request({
    url: `/wx/manage/article/save`,
    method: 'post',
    data: data
  });
}

export function deleteArticleManage(data){
  return request({
    url: `/wx/manage/article/delete`,
    method: 'post',
    data: data
  });
}


